import clsx from 'clsx';
import styles from './Card.module.css';

export function CardSubtitle({ className = '', children, as = 'div', ...rest }) {
  const Tag = as;
  return (
    <Tag className={clsx(styles.subTitle, className)} {...rest}>
      {children}
    </Tag>
  );
}
